import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=6d39a0a8"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=6d39a0a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports